export const navItems = ["首页", "关于我们", "服务项目", "工程案例", "新闻资讯", "行业方案", "智慧能碳平台", "联系我们"];

export const services = [
  {
    id: "power-testing",
    title: "电力检测与年检",
    icon: "ClipboardCheck",
    summary: "承接预防性试验、继电保护校验、绝缘检测、接地检测和安全隐患排查。",
    detail: "适用于园区、工厂、商业综合体、公共机构配电房年度检测与合规留档。",
    metric: "36h",
    metricLabel: "出具检测报告",
    fullDesc: `华能智维提供全面的电力设备检测与年度预防性试验服务，严格按照《电力设备预防性试验规程》（DL/T 596）执行。

我们的检测服务涵盖：
• 高压开关柜、变压器、电缆的绝缘电阻测试与耐压试验
• 继电保护装置定值校验与功能测试
• 接地系统电阻测试与完整性评估
• 红外热成像巡检与温升异常分析
• SF6 气体泄漏检测与微水分析
• 蓄电池组充放电试验与容量评估
• 电能质量监测与谐波分析

每项检测均按标准化流程进行，出具符合 CMA 认证要求的正式检测报告。报告包含设备编号、检测数据、判定结论和隐患整改建议，可直接用于安全审查与合规留档。`,
    features: ["CMA认证检测报告", "48小时内出具报告", "在线报告查询下载", "隐患分级管理", "复检免费", "技术顾问解读"],
    process: [
      "客户提交检测需求",
      "技术团队现场勘查",
      "制定检测方案与报价",
      "安排停电窗口/带电检测",
      "实施检测并记录数据",
      "出具正式检测报告",
      "隐患整改建议与复检"
    ],
  },
  {
    id: "substation-ops",
    title: "变电运维服务",
    icon: "ShieldCheck",
    summary: "提供配电室值守、巡检维护、故障响应、停送电操作和设备状态管理。",
    detail: "建立月度巡检台账与风险清单，降低突发停电和设备过热风险。",
    metric: "7x24",
    metricLabel: "运维响应",
    fullDesc: `依托专业的运维团队和数字化管理平台，为工业园区、商业综合体、数据中心等提供全方位变电运维服务。

运维体系：
• 7×24小时配电室值守（可选智能无人值守+远程监控）
• 日巡/周巡/月巡三级巡检制度
• 设备状态在线监测与趋势分析
• 故障15分钟响应、2小时到场承诺
• 计划性停送电操作与工作票管理
• SF6、变压器油、蓄电池等专项管理
• 备品备件管理与应急物资储备`,
    features: ["7×24小时值守", "15分钟故障响应", "数字化巡检台账", "设备状态监测", "月度运维报告", "风险预警推送"],
    process: [
      "现场评估与需求调研",
      "制定运维方案与SLA",
      "组建专属运维团队",
      "建立设备台账与基准数据",
      "实施日常巡检与维护",
      "月度总结与优化建议",
      "季度评审与持续改进"
    ],
  },
  {
    id: "equipment-service",
    title: "设备检修与安装",
    icon: "Wrench",
    summary: "覆盖高低压柜、变压器、断路器、电缆、母线槽及自动化装置施工。",
    detail: "从方案勘查、施工组织到带电前验收，保证现场交付可追溯。",
    metric: "200+",
    metricLabel: "专业技术人员",
    fullDesc: `拥有电力工程施工总承包资质和一级建造师团队，提供从方案设计、设备采购、施工安装到调试验收的全流程服务。

检修安装能力：
• 10kV-110kV 变电站新建与改造工程
• 高低压开关柜、环网柜的安装与检修
• 变压器的安装、吊芯检修与油处理
• 电缆敷设、终端制作与故障定位
• 母线槽、桥架的预制与安装
• 综合自动化系统安装与调试
• 直流系统、UPS不间断电源安装`,
    features: ["一级建造师主持", "不停产切换方案", "施工全过程监理", "带电前逐项验收", "工艺标准化", "质保期2年"],
    process: [
      "现场勘查与技术交流",
      "方案设计与设备选型",
      "施工组织设计审批",
      "材料进场与施工准备",
      "分阶段施工与质量控制",
      "竣工验收与资料移交",
      "质保期维护与回访"
    ],
  },
  {
    id: "system-upgrade",
    title: "系统升级与新能源建设",
    icon: "TrendingUp",
    summary: "实施配电系统改造、能耗监测、分布式光伏、储能和微网项目建设。",
    detail: "结合负荷曲线与用能计划，为客户降低峰谷电费和碳排压力。",
    metric: "500+",
    metricLabel: "服务项目",
    fullDesc: `聚焦新型电力系统建设，为客户提供从配电系统升级到新能源接入的一体化解决方案，助力企业实现节能降碳与绿色转型。

业务范围：
• 配电系统智能化改造与扩容升级
• 能耗在线监测系统建设与数据接入
• 分布式光伏电站设计、施工与并网
• 用户侧储能系统配置与能量管理
• 光储充一体化充电站建设
• 微电网系统规划与实施
• 需求侧响应与虚拟电厂接入`,
    features: ["投资回报分析", "EMC合同能源管理", "智慧能源云平台", "光伏25年质保", "碳资产管理", "绿证交易协助"],
    process: [
      "用能数据采集与分析",
      "定制化方案与经济测算",
      "项目备案与接入审批",
      "设备采购与施工建设",
      "并网调试与验收",
      "运营维护与数据监控",
      "持续优化与效益评估"
    ],
  },
];

export const stats = [
  ["10+", "年行业经验"],
  ["200+", "专业技术人员"],
  ["500+", "服务项目"],
  ["1000+", "合作客户"],
];

export const cases = [
  {
    id: "case-1",
    title: "苏州工业园区变电站运维项目",
    image: "/assets/hero-substation.png",
    category: "变电运维",
    result: "故障响应时间缩短 42%",
    client: "苏州工业园区管委会",
    period: "2024年3月 - 至今",
    scale: "110kV变电站 × 2座，10kV开闭所 × 8座",
    challenge: "园区供电可靠性要求高，设备老化率上升，原有运维模式响应慢、数据不透明。",
    solution: "部署远程在线监测系统，建立三级巡检体系，组建7×24小时专业运维团队，实施设备状态评估与预防性维护。",
    achievement: [
      "年均供电可靠率达到 99.97%",
      "故障响应时间从45分钟缩短至26分钟",
      "设备缺陷消除率 98.5%",
      "年度运维成本降低 22%",
      "顺利通过ISO 55001资产管理体系认证"
    ],
  },
  {
    id: "case-2",
    title: "某制造企业5.8MW分布式光伏项目",
    image: "/assets/solar-storage.png",
    category: "光伏储能",
    result: "年均节约用电成本 18%",
    client: "某大型汽车零部件制造企业",
    period: "2025年1月 - 2025年6月",
    scale: "屋顶光伏 5.8MW + 储能 2MWh",
    challenge: "企业用电量大、峰谷差价高，屋顶结构复杂，需在不停产情况下完成施工。",
    solution: "采用轻质光伏组件适配彩钢瓦屋面，配置储能系统削峰填谷，分区域分阶段施工确保生产不受影响。",
    achievement: [
      "年发电量约 638万kWh",
      "年均节约电费约 180万元",
      "减少碳排放约 3,600吨/年",
      "峰谷套利年收益约 45万元",
      "投资回收期 4.8年"
    ],
  },
  {
    id: "case-3",
    title: "无锡工厂配电系统升级改造",
    image: "/assets/distribution-room.png",
    category: "系统升级",
    result: "完成不停产切换改造",
    client: "无锡某电子元器件制造工厂",
    period: "2025年8月 - 2025年12月",
    scale: "10kV变电所改造，新增10面中压柜、3台变压器",
    challenge: "电子制造对供电连续性要求极高，原有设备老化、容量不足，需在有限空间内完成不停产改造。",
    solution: "制定分阶段停电方案，利用节假日窗口施工，配置临时供电保障，采用紧凑型开关柜设计节省空间。",
    achievement: [
      "供电容量从 4,000kVA 提升至 8,000kVA",
      "全施工周期未发生一次非计划停电",
      "新增电能质量治理装置，谐波畸变率从 12% 降至 3.5%",
      "实现全站智能化监控",
      "施工周期比行业平均水平缩短 15%"
    ],
  },
  {
    id: "case-4",
    title: "园区低压柜检修与消缺",
    image: "/assets/switchgear-service.png",
    category: "检修安装",
    result: "完成 286 项隐患整改",
    client: "南京某高新技术产业开发园区",
    period: "2025年4月 - 2025年5月",
    scale: "低压配电柜 86面，涉及 12栋建筑",
    challenge: "配电柜使用年限超过12年，存在接线松动、触头发热、绝缘老化等多类隐患，需要在春季安全大检查前完成整改。",
    solution: "制定分类分级检修计划，采用热成像+超声波综合检测手段全覆盖排查，按风险等级分批消缺。",
    achievement: [
      "完成286项隐患整改，其中严重隐患 34项",
      "柜内温升异常点从46处降为0",
      "绝缘电阻不合格回路全部恢复",
      "建立数字化设备台账与维护档案",
      "一次性通过上级安全审查"
    ],
  },
  {
    id: "case-5",
    title: "某数据中心配电系统建设",
    image: "/assets/hero-substation.png",
    category: "系统升级",
    result: "PUE从1.65降至1.38",
    client: "上海某金融数据中心",
    period: "2025年10月 - 2026年3月",
    scale: "2N冗余配电系统，总容量 20MVA",
    challenge: "金融级数据中心要求 Tier III+ 标准，配电系统需满足99.99%可用性，施工周期紧且质量要求极高。",
    solution: "采用模块化配电设计，配置智能配电列头柜与精密母线系统，部署能耗监测与智能运维平台。",
    achievement: [
      "供电可用性达到 99.997%",
      "PUE从 1.65 优化至 1.38",
      "配电系统效率提升至 98.2%",
      "全链路智能监控，故障定位时间缩短 80%",
      "获得Uptime Institute Tier III设计认证"
    ],
  },
  {
    id: "case-6",
    title: "常州产业园光储充一体化项目",
    image: "/assets/solar-storage.png",
    category: "光伏储能",
    result: "综合用电成本降低 31%",
    client: "常州某高新技术产业园",
    period: "2025年7月 - 2026年1月",
    scale: "光伏 3.2MW + 储能 4MWh + 充电桩 20台",
    challenge: "园区用电峰谷特征明显，新能源汽车充电需求快速增长，需要在有限场地内实现光储充一体化。",
    solution: "利用厂房屋顶和车棚建设光伏系统，配置储能系统参与峰谷套利，部署智能充电桩与能量管理系统。",
    achievement: [
      "光伏年发电量约 352万kWh",
      "储能峰谷套利年收益约 92万元",
      "充电桩日均服务 120车次",
      "综合用电成本降低 31%",
      "获评省级绿色低碳示范园区"
    ],
  },
];

export const certificates = [
  "承装（修、试）电力设施许可证",
  "电力工程施工总承包三级资质",
  "安全生产许可证",
  "ISO 9001 质量管理体系认证",
  "ISO 45001 职业健康安全认证",
  "ISO 14001 环境管理体系认证",
];

export const news = [
  {
    id: "news-1",
    date: "2026-08-01",
    title: "华能智维荣获2026年度电力行业科技创新奖",
    summary: "凭借'基于数字孪生的变电站智能运维系统'创新成果，荣获中国电力企业联合会颁发的年度科技创新奖。",
    image: "/assets/distribution-room.png",
    category: "公司新闻",
    content: `近日，中国电力企业联合会公布了2026年度电力行业科技创新奖获奖名单，华能智维电力科技有限公司凭借"基于数字孪生的变电站智能运维系统"项目荣获三等奖。

该系统通过构建变电设备三维数字孪生模型，结合实时运行数据与AI分析算法，实现了设备状态的精准预测和故障的早期预警。系统已在苏州工业园区等多个项目中成功应用，将设备故障预测准确率提升至92%，运维效率提高35%。

中国电力企业联合会评审专家组认为，该成果在变电运维数字化领域具有创新性和实用性，对推动电力运维行业智能化转型具有示范意义。`,
  },
  {
    id: "news-2",
    date: "2026-07-18",
    title: "公司中标南京江北新区智慧能源管理平台项目",
    summary: "中标南京江北新区智慧能源管理平台建设项目，合同金额2,800万元，服务范围覆盖园区内32家企业。",
    image: "/assets/hero-substation.png",
    category: "公司新闻",
    content: `华能智维电力近日成功中标南京江北新区智慧能源管理平台建设项目。该项目将对园区内32家重点用能企业的能源数据进行统一采集、监测和分析，搭建园区级智慧能源管理平台。

项目主要建设内容包括：部署能源数据采集终端1,200余套，建设能源大数据中心，开发碳排放管理、能效优化、需求侧响应等功能模块。项目预计2026年12月上线运行。

该项目的成功中标，标志着公司在智慧能源管理领域的服务能力获得政府和行业的高度认可。`,
  },
  {
    id: "news-3",
    date: "2026-06-28",
    title: "华能智维助力企业应对夏季用电高峰",
    summary: "夏季用电高峰期，公司运维团队全员在岗，为200余家客户提供全天候电力保障服务。",
    image: "/assets/switchgear-service.png",
    category: "服务动态",
    content: `随着夏季高温天气持续，全国各地用电负荷屡创新高。华能智维电力全面启动迎峰度夏保电预案，200余名运维工程师全员在岗，为客户提供全天候电力保障服务。

应对措施包括：
• 提前完成所有客户的设备体检和隐患排查
• 增加巡检频次，关键设备实施每日红外测温
• 配置应急发电车和备品备件
• 建立与供电公司的快速联动机制
• 开通24小时应急服务专线

截至目前，公司运维团队已处理各类故障隐患120余项，保障了所有客户的安全稳定用电。`,
  },
  {
    id: "news-4",
    date: "2026-06-15",
    title: "公司与西门子签署战略合作协议",
    summary: "与西门子（中国）签署战略合作协议，将在智能配电、数字化运维等领域开展深度合作。",
    image: "/assets/distribution-room.png",
    category: "合作动态",
    content: `6月15日，华能智维电力与西门子（中国）有限公司在上海签署战略合作协议。双方将在智能配电设备应用、数字化运维平台建设、工业物联网技术等方面开展深度合作。

根据协议，双方将：
• 共同开发基于西门子MindSphere平台的电力运维数字化解决方案
• 在智能中低压配电设备领域建立优先供应关系
• 联合开展技术培训和人才培养
• 探索在碳中和领域的合作机会

此次合作将进一步提升华能智维的技术实力和服务能力，为客户提供更具竞争力的智能配电与运维解决方案。`,
  },
  {
    id: "news-5",
    date: "2026-05-18",
    title: "华能智维完成工业园区年度配电检测与隐患治理",
    summary: "通过全量设备温升、绝缘与保护校验，保障园区夏季高负荷稳定运行。",
    image: "/assets/switchgear-service.png",
    category: "项目动态",
    content: `华能智维电力技术团队圆满完成了苏州工业园区年度配电设备检测与隐患治理工作。本次检测覆盖了园区内全部高压开关柜、变压器、电缆和继电保护装置，共发现并处理隐患286项。

技术团队采用了红外热成像、局部放电检测、油中溶解气体分析等多种先进检测手段，编制了详尽的设备状态评估报告。针对发现的问题，技术团队制定了分类分级的整改方案，并在夏季用电高峰前完成了全部消缺工作。

园区相关负责人表示，华能智维的检测服务专业、高效，为园区安全稳定运行提供了有力保障。`,
  },
  {
    id: "news-6",
    date: "2026-05-08",
    title: "分布式光伏与储能方案助力企业降低峰谷成本",
    summary: "围绕企业用电曲线部署一体化解决方案，提升新能源消纳比例。",
    content: `在当前分时电价机制下，峰谷电价差持续拉大，企业用电成本控制面临挑战。华能智维推出的"光伏+储能"一体化解决方案，正在帮助越来越多企业实现用电成本优化。

方案核心优势：
• 根据企业用电负荷曲线定制最优光伏+储能配比
• 智能能量管理系统自动参与峰谷套利
• 支持虚拟电厂接入和需求侧响应
• 灵活的商业模式：自投、EMC合同能源管理、融资租赁

截至目前，公司已累计建设分布式光伏项目超过200MW，储能项目超过50MWh，为客户年均节约用电成本1,500万元以上。`,
    image: "/assets/solar-storage.png",
    category: "技术前沿",
  },
];

export const industrySolutions = [
  {
    id: "manufacturing",
    title: "制造业电力解决方案",
    icon: "Building2",
    color: "#1f72f3",
    desc: "面向汽车、电子、化工、机械等制造行业，提供从配电系统到设备运维的全方位电力服务，保障生产线稳定运行。",
    points: ["预防性检测与设备健康管理", "不停产电力系统升级改造", "电能质量治理与节能优化", "7×24小时应急响应保障", "设备全生命周期管理"],
    cases: ["某汽车零部件企业5.8MW光伏项目", "无锡电子工厂不停产配电改造"],
  },
  {
    id: "datacenter",
    title: "数据中心电力解决方案",
    icon: "Server",
    color: "#8a63f6",
    desc: "为金融、互联网、运营商等数据中心提供高可靠配电系统设计、建设与运维服务，确保99.99%以上供电可用性。",
    points: ["2N/3N冗余配电系统设计", "精密配电与智能列头柜", "UPS系统配置与维护", "PUE优化与节能改造", "全链路智能监控与告警"],
    cases: ["某金融数据中心配电系统建设", "企业级数据中心节能改造"],
  },
  {
    id: "commercial",
    title: "商业综合体电力方案",
    icon: "Building2",
    color: "#27b875",
    desc: "为商场、写字楼、酒店等商业物业提供电力设施运维、节能管理和智能化升级服务。",
    points: ["变配电室托管运维", "中央空调节能优化", "充电桩建设与运营", "能耗监测与管理平台", "应急电源系统维护"],
    cases: ["苏州工业园区商业综合体运维", "南京某商场充电站建设"],
  },
  {
    id: "healthcare",
    title: "医疗卫生电力解决方案",
    icon: "ShieldCheck",
    color: "#ff8a1f",
    desc: "面向医院、疾控中心等医疗机构，提供符合医疗场所标准的特殊配电系统服务，确保关键医疗设备用电安全。",
    points: ["医疗IT系统(TN-S)设计与安装", "手术室/ICU等2类场所配电", "应急电源与UPS冗余配置", "定期检测与预防性维护", "电力安全评估与合规审计"],
    cases: ["三甲医院配电系统升级改造", "疾控中心应急电源建设"],
  },
  {
    id: "newenergy",
    title: "新能源及储能方案",
    icon: "Zap",
    color: "#10b8bd",
    desc: "提供分布式光伏、用户侧储能、光储充一体化等新能源项目的投资、建设与运营服务。",
    points: ["分布式光伏电站建设", "工商业储能系统", "光储充一体化方案", "微电网系统集成", "碳资产管理与绿证交易"],
    cases: ["5.8MW屋顶光伏项目", "光储充一体化产业园"],
  },
  {
    id: "public",
    title: "公共设施电力方案",
    icon: "Globe",
    color: "#e67600",
    desc: "为政府机关、学校、交通枢纽等公共设施提供电力系统建设、改造与运维服务。",
    points: ["配电系统新建与改造", "照明节能改造", "消防电气系统检测", "新能源充电设施建设", "能源托管服务"],
    cases: ["某市政府配电系统改造", "高校配电房智能化升级"],
  },
];

export const leadTrend = [
  { day: "08-01", total: 18, valid: 10 },
  { day: "08-02", total: 27, valid: 14 },
  { day: "08-03", total: 31, valid: 19 },
  { day: "08-04", total: 36, valid: 18 },
  { day: "08-05", total: 42, valid: 23 },
  { day: "08-06", total: 34, valid: 20 },
  { day: "08-07", total: 45, valid: 27 },
  { day: "08-08", total: 37, valid: 19 },
  { day: "08-09", total: 44, valid: 25 },
  { day: "08-10", total: 31, valid: 16 },
];

export const leadSources = [
  { name: "官网表单", value: 56 },
  { name: "电话咨询", value: 26 },
  { name: "合作伙伴", value: 18 },
  { name: "邮件咨询", value: 16 },
  { name: "其他渠道", value: 12 },
];

export const initialLeads = [
  { id: "INQ20260810001", company: "江苏速达工业园", contact: "张经理", phone: "138****5678", source: "官网表单", time: "2026-08-10 10:24", status: "新询盘" },
  { id: "INQ20260810002", company: "山东中能能源有限公司", contact: "李工", phone: "186****4321", source: "电话咨询", time: "2026-08-10 09:58", status: "跟进中" },
  { id: "INQ20260809003", company: "浙江科创制造有限公司", contact: "王经理", phone: "158****8765", source: "合作伙伴", time: "2026-08-09 16:43", status: "已回复" },
  { id: "INQ20260809004", company: "合肥高新产业园", contact: "陈主任", phone: "139****1122", source: "官网表单", time: "2026-08-09 15:22", status: "已转化" },
  { id: "INQ20260809005", company: "广州智建科技有限公司", contact: "刘工", phone: "137****3344", source: "邮件咨询", time: "2026-08-09 11:07", status: "跟进中" },
];

export const projects = [
  { title: "苏州工业园区变电站改造项目", image: "/assets/hero-substation.png", progress: 75, due: "2026-06-20", status: "施工中" },
  { title: "南京高新区光伏储能项目", image: "/assets/solar-storage.png", progress: 45, due: "2026-07-15", status: "施工中" },
  { title: "无锡工厂配电系统升级项目", image: "/assets/distribution-room.png", progress: 90, due: "2026-06-05", status: "调试中" },
  { title: "常州产业园电力运维服务项目", image: "/assets/switchgear-service.png", progress: 30, due: "2026-08-10", status: "准备中" },
];

export const teamMembers = [
  { name: "陈建国", role: "总经理 / 高级工程师", desc: "30年电力行业经验，主持过多个省级重点电力工程项目建设。", avatar: "/assets/team-1.png" },
  { name: "张明辉", role: "技术总监", desc: "电力系统自动化专家，负责公司技术体系搭建与质量管控。", avatar: "/assets/team-2.png" },
  { name: "李雪梅", role: "运维部经理", desc: "持有注册电气工程师证书，统筹运维团队管理及客户服务。", avatar: "/assets/team-3.png" },
  { name: "王建国", role: "工程部经理", desc: "一级建造师，主导完成百余项高低压配电工程交付。", avatar: "/assets/team-4.png" },
];

export const partners = [
  "国家电网", "南方电网", "华能集团", "中广核", "宁德时代", "比亚迪",
  "西门子", "施耐德电气", "ABB集团", "正泰电器", "德力西", "良信电器",
];

export const faqItems = [
  { q: "电力检测多久进行一次比较合适？", a: "根据《电力设备预防性试验规程》，高压设备一般每年进行一次预防性试验。对于老旧设备或运行环境恶劣的场所，建议缩短至半年。我们提供定制化检测计划，根据设备状态评估合理频次。" },
  { q: "变电运维服务包含哪些内容？", a: "包括配电室24小时值守、定期巡检、设备状态监测、故障应急处置、停送电操作、设备台账管理、风险预警报告等。可根据客户需求选择基础版、标准版或尊享版服务方案。" },
  { q: "分布式光伏项目需要多大的场地？", a: "一般500平方米以上的屋顶或空地即可建设。我们提供免费的现场勘查和方案设计，根据您的用电负荷曲线、场地条件和预算，推荐最优的光伏+储能配置方案。" },
  { q: "设备检修需要停电吗？", a: "常规检修需要停电操作，但我们会提前制定详细的停送电方案，尽量安排在低负荷时段（如夜间或节假日），并做好应急供电保障，将对生产的影响降到最低。" },
  { q: "如何选择适合的电力服务方案？", a: "我们提供免费技术咨询和现场勘查，根据您的设备状况、用电需求、预算和合规要求，量身定制服务方案。联系我们的技术顾问，2小时内即可获得初步建议。" },
  { q: "资质证书是否支持查验？", a: "所有资质证书均可在相关政府主管部门官网查询验证。我们承诺证书真实有效，客户可通过证书编号在对应监管平台查验。" },
];

export const testimonials = [
  { name: "苏州工业园区", role: "设施管理部", content: "华能智维的运维团队响应速度极快，故障响应时间缩短了40%以上，设备运行更稳定，大幅降低了我们的运维成本。", rating: 5 },
  { name: "某大型制造企业", role: "设备总监", content: "从配电系统升级到光伏储能建设，华能智维提供了全流程专业服务，方案设计合理，施工质量过硬，值得信赖的合作伙伴。", rating: 5 },
  { name: "南京某产业园区", role: "运营负责人", content: "年度配电检测服务非常专业，检测报告详实，隐患整改建议实用，帮助我们顺利通过了安全审查。", rating: 5 },
];

export const serviceProcess = [
  { step: "01", title: "需求沟通", desc: "了解客户需求、设备情况与预算范围" },
  { step: "02", title: "现场勘查", desc: "技术团队上门勘查，采集实地数据" },
  { step: "03", title: "方案设计", desc: "量身定制技术方案与报价" },
  { step: "04", title: "签约实施", desc: "签订合同，组织专业团队进场" },
  { step: "05", title: "验收交付", desc: "严格验收标准，交付完整成果" },
  { step: "06", title: "售后服务", desc: "定期回访巡查，持续技术支持" },
];

/* ===== COMPANY TIMELINE ===== */
export const timeline = [
  { year: "2014", title: "公司成立", desc: "华能智维电力科技有限公司在南京注册成立，初始团队12人。" },
  { year: "2016", title: "资质突破", desc: "取得承装（修、试）电力设施许可证和电力工程施工总承包三级资质。" },
  { year: "2018", title: "规模扩张", desc: "服务客户突破200家，技术团队扩展至80人，年营收突破5000万元。" },
  { year: "2020", title: "数字化转型", desc: "推出智慧运维管理平台，实现设备在线监测与远程诊断，通过ISO三体系认证。" },
  { year: "2022", title: "新能源布局", desc: "成立新能源事业部，启动分布式光伏与储能业务，完成首个5MW光伏项目建设。" },
  { year: "2024", title: "行业领先", desc: "累计服务客户1000+，建成光伏项目200MW+，荣获电力行业科技创新奖。" },
  { year: "2026", title: "智慧能源", desc: "中标江北新区智慧能源管理平台项目，开启园区级能源管理服务新篇章。" },
];

/* ===== CAREERS ===== */
export const careers = [
  {
    id: "job-1",
    title: "注册电气工程师",
    dept: "技术部",
    location: "南京",
    type: "全职",
    salary: "15K-25K",
    desc: "负责电力工程方案设计、技术审核与项目管理。",
    requirements: ["本科及以上学历，电气工程相关专业", "持有注册电气工程师证书", "5年以上电力工程设计或施工经验", "熟悉电力行业规范与标准"],
  },
  {
    id: "job-2",
    title: "运维工程师",
    dept: "运维部",
    location: "南京/苏州",
    type: "全职",
    salary: "8K-15K",
    desc: "负责客户配电室日常巡检维护、故障应急处理。",
    requirements: ["大专及以上学历", "持有高压电工操作证", "2年以上变配电运维经验", "能适应轮班工作制"],
  },
  {
    id: "job-3",
    title: "光伏项目经理",
    dept: "新能源事业部",
    location: "南京",
    type: "全职",
    salary: "12K-20K",
    desc: "负责分布式光伏项目的现场管理、施工协调与验收交付。",
    requirements: ["本科及以上学历", "持有二级建造师证书", "3年以上光伏项目管理经验", "熟悉光伏并网流程"],
  },
  {
    id: "job-4",
    title: "销售经理",
    dept: "市场部",
    location: "南京",
    type: "全职",
    salary: "10K-18K + 提成",
    desc: "开拓工业客户市场，维护客户关系，完成销售目标。",
    requirements: ["大专及以上学历", "3年以上B2B销售经验", "有电力/能源行业背景优先", "良好的沟通协调能力"],
  },
  {
    id: "job-5",
    title: "前端开发工程师",
    dept: "技术研发部",
    location: "南京",
    type: "全职",
    salary: "12K-22K",
    desc: "负责智慧能源管理平台的前端开发与优化。",
    requirements: ["本科及以上学历，计算机相关专业", "精通React/Vue等主流框架", "3年以上前端开发经验", "有数据可视化经验优先"],
  },
];

/* ===== DOWNLOADS ===== */
export const downloads = [
  { id: "dl-1", title: "华能智维电力公司简介手册", type: "PDF", size: "8.6 MB", icon: "FileText" },
  { id: "dl-2", title: "电力检测与年检服务手册", type: "PDF", size: "4.2 MB", icon: "FileText" },
  { id: "dl-3", title: "变电运维服务方案介绍", type: "PDF", size: "5.8 MB", icon: "FileText" },
  { id: "dl-4", title: "分布式光伏解决方案白皮书", type: "PDF", size: "12.3 MB", icon: "FileText" },
  { id: "dl-5", title: "配电系统改造技术指南", type: "PDF", size: "7.1 MB", icon: "FileText" },
  { id: "dl-6", title: "设备检修安全操作规程", type: "DOC", size: "3.5 MB", icon: "FileText" },
  { id: "dl-7", title: "电力检测报告模板（样本）", type: "PDF", size: "1.8 MB", icon: "FileText" },
  { id: "dl-8", title: "储能系统应用技术白皮书", type: "PDF", size: "9.4 MB", icon: "FileText" },
];

/* ===== ABOUT PAGE CONTENT ===== */
export const aboutContent = {
  vision: "成为国内领先的智慧电力服务提供商",
  mission: "以专业技术和创新服务，保障客户电力系统安全高效运行，助力能源转型与可持续发展",
  values: [
    { title: "安全第一", desc: "安全是一切工作的前提，严格执行安全规范" },
    { title: "专业至上", desc: "持续提升技术能力，保持行业领先专业水准" },
    { title: "客户为本", desc: "深度理解客户需求，提供量身定制的解决方案" },
    { title: "创新驱动", desc: "拥抱新技术，推动电力运维行业数字化转型" },
  ],
  advantage: [
    { title: "资质齐全", desc: "具备电力工程施工总承包、电力设施承装（修、试）、安全生产许可等全套资质。" },
    { title: "技术团队", desc: "200余名专业技术人员，含一级建造师、注册电气工程师等技术骨干。" },
    { title: "智能平台", desc: "自研智慧运维管理平台，实现设备在线监测、故障预警和数据分析。" },
    { title: "快速响应", desc: "7×24小时运维服务，15分钟故障响应，2小时到场承诺。" },
    { title: "全链服务", desc: "从检测、运维、检修到新能源建设，提供贯穿全生命周期的服务。" },
    { title: "行业深耕", desc: "10年以上行业经验，服务覆盖制造、数据中心、医疗、商业等多领域。" },
  ],
};